import React from 'react'
import '../css/wait.scss'
function Wait() {
    return (
        <div className="wait">
            Please wait
            <div className="balls">
                <div className="c1"></div>
                <div className="c2"></div>
                <div className="c3"></div>
            </div>
 
        </div>
    )
}

export default Wait
